import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { ButtonModule, SharedModule, InputTextModule, AutoCompleteModule, DropdownModule, CalendarModule, TooltipModule, DialogModule, TreeTableModule } from "primeng/primeng";
import { InputTrimModule } from "../../../directives/input-trim";
import { GroupHoardingDialogComponent } from "./group-hoarding-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        ButtonModule,
        SharedModule,
        InputTextModule,
        AutoCompleteModule,
        DropdownModule,
        CalendarModule,
        TooltipModule,
        InputTrimModule,
        DialogModule,
        TreeTableModule
    ],

    declarations: [
        GroupHoardingDialogComponent
    ],

    exports: [
        GroupHoardingDialogComponent
    ],
    providers: []
})

export class GroupHoardingDialogModule { }